export default "__VITE_PUBLIC_ASSET__64f27559__"